import i18n from "../../../../i18n/i18n";

/**
 * last and news list of Messages global uses
 */
 export var validationMessage=[];

/**
 * 
 */
 const EntrykeysValidationMessage={
    DebitAndCredit_Required:'DebitAndCredit_Required',
    DebitAndCredit_OneOf:'DebitAndCredit_OneOf',

    CurrencyDebitAndCredit_Required:'CurrencyDebitAndCredit_Required',
    CurrencyDebitAndCredit_OneOf:'CurrencyDebitAndCredit_OneOf',

    DebitWithCurrencyDebit_Relation:'DebitWithCurrencyDebit_Relation',
    CreditWithCurrencyCredit_Relation:'CreditWithCurrencyCredit_Relation',
    
    CurrencyTypePrice_Required:'CurrencyTypePrice_Required',
}


/**
 * dictionary contain message
 */
const EntryValidationMessage = {
    DebitAndCredit_Required:{
        ar: "يجب إدخال إحدى حقول المدين / الدائن",
        en: "One of the debit / credit fields must be entered",
        es: "Se debe ingresar uno de los campos de débito/crédito",
    },
    DebitAndCredit_OneOf:{
        ar: "لا يمكن إدخال مدين ودائن ضمن قيد واحد",
        en: "Debit and credit can't be entered in one entry",
        es: "El débito y el crédito no se pueden ingresar en un solo asiento",
    },

    CurrencyDebitAndCredit_Required:{
        ar: "يجب إدخال إحدى حقول عملة مدينة / عملة دائنة",
        en: "One of the foreign currency credit / debit must be entered",
        es: "Se debe ingresar una de las monedas de débito/crédito",
    },
    CurrencyDebitAndCredit_OneOf:{
        ar: "لا يمكن إدخال عملة دائنة وعملة مدينة ضمن قيد واحد",
        en: "Foreign currency debit and foreign currency credit can't be entered in the same entry",
        es: "La moneda de débito y crédito no se puede ingresar en el mismo asiento",
    },
    
    DebitWithCurrencyDebit_Relation:{
        ar: "يشترط توافق ملء كلا من مدين مع عملة مدينة",
        en: "Specify Foreign currency debit for debit (incompatible inputs)",
        es: "Especifique la moneda de débito para el deudor (entradas incompatibles)",
    },
    CreditWithCurrencyCredit_Relation:{
        ar: "يشترط توافق ملء كلا من دائن مع عملة دائنة",
        en: "Specify foreign currency credit for credit (incompatible inputs)",
        es: "Especifique la moneda de crédito para el acreedor (entradas incompatibles)",
    },

    CurrencyTypePrice_Required:{
        ar: "يجب اختيار نوع العملة ثم ضبط السعر",
        en: "Choose currency before",
        es: "Elija la moneda antes de agregar el precio",
    },
};


function pushMessage(key){
    let message= EntryValidationMessage[key][i18n.locale];
    if(!validationMessage.includes(message)){
        validationMessage.push(message);
    }
}

function intiLinkedRules(linkedRules){
    Object.keys(linkedRules).forEach(value => linkedRules[value] = true)
}



// replace some words to agent
function formatToCashTerm(messages){
    for (let index = 0; index < messages.length; index++) {
        if (i18n.locale === 'ar'){
            messages[index] = messages[index].replace("المدين", "الوارد");
            messages[index] = messages[index].replace("الدائن", "الصادر");
            messages[index] = messages[index].replace("مدين", "وارد");
            messages[index] = messages[index].replace("دائن", "صادر");
            messages[index] = messages[index].replace("مدينة", "واردة");
            messages[index] = messages[index].replace("دائنة", "صادرة");
        }

        else if (i18n.locale === 'en'){
            messages[index] = messages[index].replace("debit", 'revenue');
            messages[index] = messages[index].replace("Debit", 'Revenue');
            messages[index] = messages[index].replace("credit", 'expense');
            messages[index] = messages[index].replace("Credit", 'Expense');
        }

        else if (i18n.locale === 'es'){
            messages[index] = messages[index].replace("débito", 'entrante');
            messages[index] = messages[index].replace("Débito", 'Entrante');
            messages[index] = messages[index].replace("credit", 'resultado');
            messages[index] = messages[index].replace("Crédito", 'Resultado');
        }
    }
    return messages;
}



/**
 * Detected change entry row of founds table and enabled valid scenarios.
 *
 * @param {Object} entry entry object .
 * @param {Object} linkedRules dictionary of rules.
 * @return {Array} array of validationMessages.
 */
export function entryDetectedValidation(entry,linkedRules){

    validationMessage=[];//clear old =0
    intiLinkedRules(linkedRules);

    // debit  credit
    if(entry.debit==null && entry.credit==null){
        pushMessage(EntrykeysValidationMessage.DebitAndCredit_Required);
        linkedRules.debit=false;
        linkedRules.credit=false;
    }
    if(entry.debit!=null && entry.credit!=null )
    {
        pushMessage(EntrykeysValidationMessage.DebitAndCredit_OneOf);
        linkedRules.debit=false;
        linkedRules.credit=false;
    }
    
    // // currency debit  credit
    // if(entry.currency_debit==null && entry.currency_credit==null){
    //     pushMessage(EntrykeysValidationMessage.CurrencyDebitAndCredit_Required);
    //     linkedRules.currency_debit=false;
    //     linkedRules.currency_credit=false;
    // }
    if(entry.currency_debit!=null && entry.currency_credit!=null )
    {
        pushMessage(EntrykeysValidationMessage.CurrencyDebitAndCredit_OneOf);
        linkedRules.currency_debit=false;
        linkedRules.currency_credit=false;
    }


    // {debit  with  currency_debit }  {credit  with  currency_credit } 
    if(entry.debit!=null && entry.currency_credit!=null){
        pushMessage(EntrykeysValidationMessage.DebitWithCurrencyDebit_Relation);
        linkedRules.debit=false;
        linkedRules.currency_credit=false;
    }
    if(entry.credit!=null && entry.currency_debit!=null){
        pushMessage(EntrykeysValidationMessage.CreditWithCurrencyCredit_Relation);
        linkedRules.credit=false;
        linkedRules.currency_debit=false;
    }


    // select currency then price
    if(entry.currency_id==null && entry.currency_price!=null){
        pushMessage(EntrykeysValidationMessage.CurrencyTypePrice_Required);
        linkedRules.currency_id=false;
    }
    // Prevent inserting currency id and price without specifying currency credit/debit
    if(entry.currency_id !=null && entry.currency_price != null && entry.credit != null && entry.currency_credit == null){
        pushMessage(EntrykeysValidationMessage.CreditWithCurrencyCredit_Relation);
        linkedRules.currency_credit=false;
    }
    // Prevent inserting currency id and price without specifying currency credit/debit
    if(entry.currency_id !=null && entry.currency_price != null && entry.debit != null && entry.currency_debit == null){
        pushMessage(EntrykeysValidationMessage.DebitWithCurrencyDebit_Relation);
        linkedRules.currency_debit=false;
    }
    return validationMessage;
}


/**
 * Detected change entry row of founds table and enabled valid scenarios.
 * apply for Cash Term
 * @param {Object} entry entry object .
 * @param {Object} linkedRules dictionary of rules.
 * @return {Array} array of validationMessages.
 */
export function entryCashDetectedValidation(entry,linkedRules){
   return formatToCashTerm(entryDetectedValidation(entry,linkedRules));
}